import { get, post, del, put } from '@/libs/api.request'

export const getAssembledPartCostEstimators = (params) => {
  return get('/cost-estimators/assembled-part-cost', params)
}

export const deleteAssembledPartCostEstimator = (id) => {
  return del(`/cost-estimators/${id}/assembled-part-cost`)
}

export const updateAssembledPartCostEstimator = (id, data) => {
  return put(`/cost-estimators/${id}/assembled-part-cost`, data)
}

export const createAssembledPartCostEstimator = (data) => {
  return post('/cost-estimators/assembled-part-cost', data)
}

export const attachCostEstimatorToEntity = (id, data) => {
  return post(`/cost-estimators/${id}/attach`, data)
}
